export default __webpack_public_path__ + "82a248f6819e6a6ab260e65ad3dc2dad.jpg";